module.exports = __webpack_public_path__ + "static/media/logo-external.ed611fe4.png";